/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
const theme = {
  appearances: {
    icon: { type: 'variant', values: [ true ] },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    {
      if: { validation: 'success' },
      tokens: {
        backgroundColor: '#f4f9f2',
        borderColor: '#f4f9f2',
        color: '#163e06'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        backgroundColor: '#fff6f8',
        borderColor: '#fff6f8',
        color: '#c12335'
      }
    },
    {
      if: { icon: true, validation: 'success' },
      tokens: { icon: PaletteIconStatusSuccess, iconColor: '#2b8000' }
    },
    {
      if: { icon: true, validation: 'error' },
      tokens: { icon: PaletteIconStatusError, iconColor: '#c12335' }
    }
  ],
  tokens: {
    backgroundColor: '#efedff',
    borderColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    borderWidth: 1,
    color: '#2c2e30',
    contentFontSize: 16,
    fontName: 'HNforTELUSSA',
    fontWeight: '400',
    icon: null,
    iconColor: 'rgba(0, 0, 0, 0)',
    iconGap: 8,
    iconSize: 24,
    lineHeight: 1.5,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    space: 2,
    titleFontSize: 16
  }
}
export default theme
